(function() {
  if ('connection' in navigator && navigator.connection.saveData) return;

  var seen = new Set();
  var supportsPrefetch = (function() {
    try {
      var l = document.createElement('link');
      return l.relList.supports('prefetch');
    } catch (e) {
      return false;
    }
  })();

  function addPrefetch(href) {
    if (!href || seen.has(href)) return;
    seen.add(href);

    if (supportsPrefetch) {
      var link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = href;
      link.as = 'document';
      document.head.appendChild(link);
    } else {
      requestIdleCallback?.(function() {
        fetch(href, { mode: 'no-cors', credentials: 'include' }).catch(() => {});
      });
    }
  }

  function isLocal(url) {
    try {
      var u = new URL(url, location.href);
      return u.origin === location.origin;
    } catch (e) {
      return false;
    }
  }

  function shouldSkip(a) {
    if (!a) return true;
    if (a.target && a.target !== '_self') return true;
    var href = a.getAttribute('href') || '';
    if (href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) return true;
    if (!isLocal(href)) return true;
    if (a.hasAttribute('data-pt-skip')) return true;
    return false;
  }

  document.addEventListener('mouseover', function(e) {
    var a = e.target.closest('a');
    if (shouldSkip(a)) return;
    addPrefetch(a.href);
  }, { passive: true });

  // Prefetch visible links
  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(ent) {
      if (ent.isIntersecting) {
        var a = ent.target;
        addPrefetch(a.href);
        io.unobserve(a);
      }
    });
  }, { rootMargin: '200px' });

  document.querySelectorAll('a[href]').forEach(function(a) {
    if (!shouldSkip(a)) io.observe(a);
  });
})();
